<template>
    
    <div class="footer">
            <div class="container w1000">
                <div class="cols">                    
                        <div class="row">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M24 8H16V0H24V8ZM18 6H22V2H18V6Z" fill="#32AADE"/>
                                <path d="M13 11V5H5V19H19V11H13ZM7 7H11V11H7V7ZM11 17H7V13H11V17ZM17 17H13V13H17V17Z" fill="#32AADE"/>
                                <path d="M22 24H2C1.46957 24 0.960859 23.7893 0.585786 23.4142C0.210714 23.0391 0 22.5304 0 22V2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0H12V2H2V22H22V12H24V22C24 22.5304 23.7893 23.0391 23.4142 23.4142C23.0391 23.7893 22.5304 24 22 24Z" fill="#32AADE"/>
                            </svg>
                            <div class="column left ml4">
                                <p >JSON Corp, 2025©</p>                                
                                <p>Email: <a href="mailto:a@senthy.com">a@senthy.com</a></p>
                                <p>Phone: +1 (350) 206-0333</p>                                
                            </div>                            
                        </div>                    
                </div>

               <!--  <div class="cols">
                    <router-link class="item" v-for="(item, index) in action" :key="index" :to="item.link">{{t(item.id)}}</router-link>
                </div>

                <div class="cols">
                    <router-link class="item" v-for="(item, index) in action" :key="index" :to="item.link">{{t(item.id)}}</router-link>
                </div>

                <div class="cols">
                    <router-link class="item" v-for="(item, index) in action" :key="index" :to="item.link">{{t(item.id)}}</router-link>
                </div> -->

                <div class="cols">
                    <p class="item">Dark mode</p>
                    <Mode :dark="db.settings.dark" @change="db.settings.dark = !db.settings.dark"></Mode>
                </div>
            </div>

            <!-- <div class="center row">
                <p class="item wide" @click="go('about.personal')">Персональные данные</p>
                <p class="item wide" @click="go('about.offer')">Оферта</p>
                <p class="item wide" @click="go('about.user')">Пользовательское соглашение</p>
                <p class="item wide" @click="go('about.req')">Реквизиты</p>
            </div> -->
        
        
    </div>
    
    
</template>
<script>
import { useI18n } from 'vue-i18n';
export default {
    data: function () {return {
        action: [
            { id: 'home', link:'/'},
            { id: 'search', link:'/search'},
            { id: 'people', link:'/people'},
            { id: 'top', link:'/top'},
            { id: 'wait', link:'/wait'},
        ],
        policy: [
            { id: 'home', link:'/'},
            { id: 'search', link:'/search'},
            { id: 'people', link:'/people'},
            { id: 'top', link:'/top'},
            { id: 'wait', link:'/wait'},
        ],
    }},
    setup() {
            const { t } = useI18n({
            inheritLocale: true,
            useScope: 'local'
        })
        return { t }
    },
    components:{},
    props:{
        
    },
}
</script>

<i18n>
{
  "en": {
    "home": "Home",
    "search": "Search",
    "people": "People",
    "top": "Top 100",
    "wait": "Waitlist",
  }
}
</i18n>

<style scoped>
.footer{
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100vw;
    padding: 50px 0 20px;
    background: var(--footer);
    margin-top: 20vh;
}

.container{
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    max-width: 1200px;
    background: none;
    margin-bottom: 100px;

}

.brandtext{
    font-style: normal;
    font-weight: 600;
    margin-left: 15px;
    color: var(--text);
}

.cols{
    position: relative;
    display: flex;
    flex-direction: column;
    margin: 0 50px;
    align-items: flex-start;
    justify-content: flex-start;
}

.logo{
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
}
.logo p{
    color:  var(--text);
    text-align: left;
    font-size: 11px;
    line-height: 15px;
    margin-left: 10px;
}


.item{
    cursor: pointer;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    letter-spacing: 0.0em;
    color:  var(--g4);
    text-decoration: none;
    margin: 0 0px 6px;
    white-space: nowrap;
}

.wide{
    margin: 0 10px;
}
.item.router-link-exact-active{
    opacity: .3;
}
</style>

